
export default {
  mapForm: {
    placesAndDirections: 'Encontrar & ir',
    isochrones: 'Alcançar',
    uploadedContentRendered: 'O conteúdo carregado está pronto',
    errorRenderingContentUploaded: 'Erro ao processar o conteúdo carregado. Verificar o formato e o conteúdo do arquivo'
  }
}
